// function 提供風景區相關表格使用
// TBROC: scenic_area_alert scenic_area_management
// NTPC: coastal_warning
import { generate_sign_icon_html } from "@/utils/monitor/multiple_signs.js"

export const icons = {
    '雨量警示': {
        '警戒': { 'file_name': 'rain3', 'color': 'yellow', },
        '預警': { 'file_name': 'rain2', 'color': 'orange', },
        '行動': { 'file_name': 'rain1', 'color': 'red', },
        'name': 'icon-rainfall-warning',
        'show_opacity': true,
        'color': 'green'
    },
    '大風警戒': { 'name': 'icon-gale-warning', 'show_opacity': true, 'color': 'green' },
    '高溫警示': { 'name': 'icon-high-temperature', 'show_opacity': true, 'color': 'green' },
    '低溫警示': { 'name': 'icon-low-temperature', 'show_opacity': true, 'color': 'green' },
    '長浪警戒': { 'name': 'icon-long-wave-warning', 'show_opacity': true, 'color': 'blue' },
    '浪高警戒': { 'name': 'icon-breaker-hight-warning', 'show_opacity': true, 'color': 'blue' },
    '高海溫警示': { 'name': 'icon-high-sea-temperature', 'show_opacity': true, 'color': 'blue' },
    '低海溫警示': { 'name': 'icon-low-sea', 'show_opacity': true, 'color': 'blue' },
};

export const reconstruct_signs_structure = (data) => {
    return data.map(datum => {
        return {
            "idx": `
                ${datum['風景管理處']}
                ${datum['項次']}
            `,
            "idx_for_sort": datum['項次'],
            "sign_icons" : generate_sign_icon_html(datum, icons)
        }
    })
}

export const merge_data_by_item = (data) => {
    const temp_store_items = []
    const merged_data = []
    data.forEach(datum => {
        if (!temp_store_items.includes(datum['項次'])) {
            temp_store_items.push(datum['項次'])
            merged_data.push(datum)
        }else {
            const should_merge_datam = merged_data.find(merged_datum => {
                return merged_datum['項次'] === datum['項次']
            })

            Object.keys(datum).forEach(key => {
                if (icons[key]) {
                    const icon_keys = Object.keys(icons[key])
                    // 處理雨量警戒
                    if(icon_keys.includes(datum[key]['燈號'])) {
                        const merged_datum_rain_index = icon_keys.findIndex(key2 => key2 === should_merge_datam[key]['燈號'])
                        const datum_rain_index = icon_keys.findIndex(key2 => key2 === datum[key]['燈號'])
                        if (merged_datum_rain_index < datum_rain_index) {
                            should_merge_datam[key]['燈號'] = datum[key]['燈號']
                        }
                    // 其他的
                    } else if(icons[key]['file_name'] && datum[key]['燈號']) {
                      should_merge_datam[key]['燈號'] =  should_merge_datam[key]['燈號'] || datum[key]['燈號']
                    } 
                }
            })

        }
    })
    
    return merged_data
}

export const merge_by_property = (target, source, compare_key, combine_keys = []) => {
    source.forEach(source_element => {
        let target_element = target.find(target_element => {
            return source_element[compare_key] === target_element[compare_key];
        })
        if(target_element) {
            if (combine_keys.length !== 0) {
                combine_keys.forEach(combine_key => {
                    target_element[combine_key] = target_element[combine_key].concat(source_element[combine_key])
                })
            } else {
                Object.assign(target_element, source_element)
            }
        } else {
            source_element['sign_icons'] = ['-', '-', '-', '-', ...source_element['sign_icons']] 
            target.push(source_element)
        }
    })

    target.forEach(target_element => {
        if (target_element['sign_icons'].length === 4) {
            target_element['sign_icons'] = [...target_element['sign_icons'], '-', '-', '-', '-']
        }
    })
    return target
}  